import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import { Url } from '@wix/da-url';
import ConfirmationPopup from '@wix/da-shared-react/pkg/Popup/ConfirmationPopup';
import BiLink from '@wix/da-shared-react/pkg/biLogger/Components/BiLink';

export interface Props {
  group: PapiUser;
  popModal: () => void;
}

const GroupJoinPendingModal: React.FC<Props> = ({ group, popModal }) => {
  const { t } = useTranslation();
  return (
    <ConfirmationPopup
      onConfirm={popModal}
      onCancel={popModal}
      title={t('group.join.pending.popup.title')}
      text={
        <div>
          <div>
            {/* prettier-ignore */}
            <Trans i18nKey="group.join.pending.popup.body">
              You’ll get notified if you’re accepted into {{ groupname: group.username }}.
              To check the status of your request or withdraw it, go to the
              <BiLink href={`${Url.feedbackLink()}/correspondence`}>correspondence</BiLink>
              tab in your notifications.
            </Trans>
          </div>
        </div>
      }
      withCancelButton={false}
      confirmBtnLabel={t('group.join.pending.popup.button.accept')}
      isOpen
    />
  );
};
GroupJoinPendingModal.displayName = 'GroupJoinPendingModal';

export default GroupJoinPendingModal;
